import { i18n } from '@base-app/web2'
import enUS from './locales/en-US/admin-mobifull.json'
import ptBR from './locales/pt-BR/admin-mobifull.json'

i18n.addResourceBundle('en-US', 'admin-mobifull', enUS)
i18n.addResourceBundle('pt-BR', 'admin-mobifull', ptBR)
